import Vue from 'vue'
import Vuex from 'vuex'
import ApiService from '../services/api.service'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        products : [],
        productHistory : [],
        notifications:[]
      },
    getters: {
      getProduct ( state, index )  {
        return state.products[index];
      },
      getProductHistory ( state )  {
        return state.productHistory;
      },
      getAllProducts ( state )  {
        return state.products;
      },
      getTrackedProducts ( state ) {
        //return state.products;
        return state.products.filter(product => {
          return product.is_tracked;
        })
      },
      getNotifications (state){
        return state.notifications;
      }
    },
    mutations: {
        SET_PRODUCTS : (state,payload) => {
          state.products = payload
        },
        SET_PRODUCTS_HISTORY: (state, payload) => {
          state.productHistory = payload
        },
        ADD_PRODUCT : (state,payload) => {
          state.products.push( payload );
          // Edit product
          //Object.assign(state.products[payload.index], payload.editedItem)
        },
        REMOVE_PRODUCT : (state,payload) => {
          state.products.splice(payload.index, 1)
        },
        SET_NOTIFICATION: (state,payload) =>{
          state.notifications.push({type:payload.type, content:payload.content})
        },
        CLEAR_NOTIFICATIONS: (state) =>{
          state.notifications = []
        }
    },
    actions :{
      GET_ALL_PRODUCTS : async (context) => {
        const requestData =  {
            method: 'get',
            url: "/products/tracked"
        } 
        let { data } = await ApiService.customRequest(requestData)
        context.commit('SET_PRODUCTS',data)
      },
      GET_PRODUCTS: async (context) => {
        const requestData =  {
            method: 'get',
            url: "/products/listing",
        } 
        let { data } = await ApiService.customRequest(requestData)
        context.commit('SET_PRODUCTS',data)
      },
      GET_PRODUCT_HISTORY : async (context,payload) => {
        const requestData =  {
            method: 'get',
            url: "/products/history/"+ payload
        } 
        let { data } = await ApiService.customRequest(requestData)
        context.commit('SET_PRODUCTS_HISTORY', data)
      },
      EMPTY_PRODUCT_HISTORY : async (context) => {
        context.commit('SET_PRODUCTS_HISTORY', [])
      },
      SET_TRACKED_PRODUCT : async (context,payload) => {
        const requestData =  {
            method: 'put',
            url: "/products/track/"+ payload
        } 
        await ApiService.customRequest(requestData)
        
        // Refresh products list
        context.dispatch('GET_PRODUCTS')
      },
      SAVE_PRODUCT : async (context,payload) => {
        const requestData =  {
          method: 'post',
          url: "/products",
          data: {
            asin: payload
          }
        }
        await ApiService.customRequest(requestData)

        // Refresh products list
        context.dispatch('GET_PRODUCTS')
      },
      DELETE_PRODUCT : async (context,payload) => {
        //let { data } = await ApiService.post('/todo')
        context.commit('REMOVE_PRODUCT',payload)
      },
    }
  })